// @flow

import React, {type Node} from 'react';
import ReactDOM from 'react-dom';

import styled from 'styled-components';

const StyledBackdropDiv = styled.div`
  background: rgba(255, 255, 255, 0.75);
  position: absolute !important;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;

  &.bd-enter,
  &.bd-appear,
  &.bd-exit.bd-exit-active {
    opacity: 0.01;
    > * {
      top: calc(50% - 10px);
    }
  }

  &.bd-exit,
  &.bd-enter.bd-enter-active,
  &.bd-appear.bd-appear-active {
    opacity: 1;
    > * {
      top: 50%;
    }
  }

  &.bd-exit-active,
  &.bd-enter-active,
  &.bd-appear-active {
    transition: all 250ms ease-out;
    > * {
      transition: all 250ms;
    }
  }

  > * {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  > .connector.loading {
    opacity: 0;
    transition: all 250ms ease-out;
  }
`;

type Props = {
  children: Node,
};

export class BieBackDrop extends React.PureComponent<Props> {
  static id = 'bie-backdrop-container';
  portalTarget = BieBackDrop.getOrCreateContainer();

  static getOrCreateContainer() {
    let container = window.document.getElementById(BieBackDrop.id);
    if (container == null) {
      container = document.createElement('div');
      container.setAttribute('id', BieBackDrop.id);
      window.document.body.appendChild(container);
    }
    return container;
  }

  render() {
    const {children, ...other} = this.props;

    return ReactDOM.createPortal(
      <StyledBackdropDiv {...other}>{children}</StyledBackdropDiv>,
      this.portalTarget
    );
  }
}
